export default "__VITE_ASSET__B3Tvrh3s__ 1920w";